/* BAD 'EM UP theme script */
(function () {
  "use strict";
  var B = window.BEU || {};
  B.routes = B.routes || { root: "/", cart: "/cart", add: "/cart/add", change: "/cart/change", shop: "/collections/all" };
  B.meta = B.meta || {};
  B.products = B.products || {};
  B.assets = B.assets || {};

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var REDUCE = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var FINE = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
  var SMOOTH = REDUCE ? "auto" : "smooth";
  var ARROW = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  /* ---------- money, formatted like the store's own price format ---------- */
  function money(cents) {
    var fmt = B.money || "€{{amount}}";
    var n = Number(cents) / 100;
    function num(dec, th, ds) {
      var p = n.toFixed(dec).split(".");
      var i = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return p[1] ? i + ds + p[1] : i;
    }
    var out = fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case "amount_no_decimals": return num(0, ",", ".");
        case "amount_with_comma_separator": return num(2, ".", ",");
        case "amount_no_decimals_with_comma_separator": return num(0, ".", ",");
        case "amount_with_apostrophe_separator": return num(2, "'", ".");
        case "amount_with_period_and_space_separator": return num(2, " ", ".");
        default: return num(2, ",", ".");
      }
    });
    return out.replace(/<[^>]*>/g, "").replace(/([.,]00)(?!\d)/, "");
  }

  /* ---------- product data from the theme ---------- */
  var META = {};
  Object.keys(B.meta).forEach(function (h) {
    var f = String(B.meta[h] || "").split("|");
    if (f.length < 12) return;
    META[h] = {
      h: h, no: f[0], role: f[1], tint: f[2], glow: f[3], mark: f[4], key: f[5], line: f[6], colour: f[7],
      type: f[8], x: Number(f[9]), y: Number(f[10]), name: f[11], panel: f[12],
      specs: (f[13] || "").split("^").filter(Boolean).map(function (x) { return x.split("~"); }),
      price: f[14] ? Number(f[14]) : null
    };
  });
  function prod(h) { return B.products[h] || null; }
  function live(h) { var p = prod(h); return !!(p && p.available); }
  function nameOf(h) { var p = prod(h); return p ? p.title : META[h].name; }
  function priceOf(h) { var p = prod(h), m = META[h]; return p ? money(p.price) : (m.price ? money(m.price) : ""); }
  function img(m, kind) { return B.assets[m.key + "-" + kind] || ""; }
  function mainImg(m) { return img(m, m.type === "tee" ? "front" : "tie"); }
  /* every tee shows in the hero, on sale or not; drafts get a "coming soon" card instead of sizes */
  var TEES = Object.keys(META).filter(function (h) { return META[h].type === "tee"; });

  /* ---------- messages ---------- */
  function setMsg(ctx, text, isErr) {
    var el = ctx && document.getElementById(ctx + "-msg");
    if (!el) return;
    el.textContent = text || "";
    el.classList.toggle("err", !!isErr);
  }
  function needSize(ctx) {
    setMsg(ctx, "Pick a size first.", true);
    var g = $('.sizes[data-ctx="' + ctx + '"]');
    if (!g) return;
    var r = g.getBoundingClientRect();
    if (r.top < 90 || r.bottom > window.innerHeight - 90) g.scrollIntoView({ behavior: SMOOTH, block: "center" });
    if (!REDUCE && g.animate) g.animate([{ transform: "translateX(0)" }, { transform: "translateX(-7px)" }, { transform: "translateX(7px)" }, { transform: "translateX(-4px)" }, { transform: "translateX(0)" }], { duration: 380 });
  }

  /* ---------- bag (Shopify cart) ---------- */
  var cart = null;
  function jsonFetch(url, body) {
    var opts = { headers: { Accept: "application/json" } };
    if (body) { opts.method = "POST"; opts.headers["Content-Type"] = "application/json"; opts.body = JSON.stringify(body); }
    return fetch(url, opts).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || "That didn’t work. Try again.");
        return data;
      });
    });
  }
  function loadCart() { return jsonFetch(B.routes.cart + ".js").then(function (c) { cart = c; renderCart(); return c; }); }
  function addToBag(variantId, qty, label, ctx, btn) {
    if (btn) { btn.disabled = true; btn.setAttribute("aria-busy", "true"); }
    return jsonFetch(B.routes.add + ".js", { items: [{ id: Number(variantId), quantity: qty || 1 }] })
      .then(function () { return loadCart(); })
      .then(function () {
        setMsg(ctx, "");
        toast((qty > 1 ? qty + " × " : "") + (label || "Added to your bag"));
        $$(".bagbtn").forEach(function (b) { b.classList.remove("bump"); void b.offsetWidth; b.classList.add("bump"); });
      })
      .catch(function (e) { if (ctx) setMsg(ctx, e.message, true); else toast(e.message, true); })
      .then(function () { if (btn) { btn.disabled = false; btn.removeAttribute("aria-busy"); } });
  }
  function changeLine(key, qty) {
    return jsonFetch(B.routes.change + ".js", { id: key, quantity: qty }).then(function (c) { cart = c; renderCart(); })
      .catch(function (e) { toast(e.message, true); });
  }
  function lineImg(it) {
    var m = META[it.handle];
    if (m) return mainImg(m);
    if (!it.image) return "";
    return it.image + (it.image.indexOf("?") > -1 ? "&" : "?") + "width=240";
  }
  function renderCart() {
    if (!cart) return;
    var n = cart.item_count;
    $$(".bag-n").forEach(function (e) { e.textContent = n; });
    var bb = $("#bagBtn");
    if (bb) bb.setAttribute("aria-label", "Open bag, " + n + " item" + (n === 1 ? "" : "s"));
    var count = $("#drCount"), body = $("#drBody"), ft = $("#drFt");
    if (!body) return;
    if (count) count.textContent = n ? n : "";
    var inBag = {};
    cart.items.forEach(function (i) { inBag[i.handle] = true; });
    var ups = TEES.filter(function (h) { return !inBag[h] && live(h); });
    var upsHTML = ups.length ? '<div class="ups"><p class="k">' + (n ? "Add another tee" : "Start with a tee") + '</p><div class="ups-row">' + ups.map(function (h) {
      var m = META[h], p = prod(h);
      return '<a class="ups-item" href="' + esc(p.url) + '"><span class="stage" style="--tint:' + m.tint + '"><img src="' + esc(img(m, "front")) + '" alt=""></span><span><b>' + esc(p.title) + "</b><small>" + money(p.price) + " · " + esc(m.colour) + '</small></span><span class="go">' + ARROW + "</span></a>";
    }).join("") + "</div></div>" : "";
    if (!n) {
      body.innerHTML = '<div class="empty"><p class="d">Your bag<br>is empty</p><p>Pick a tee and it lands here.</p></div>' + upsHTML;
      if (ft) ft.hidden = true;
      return;
    }
    if (ft) ft.hidden = false;
    body.innerHTML = cart.items.map(function (it) {
      var m = META[it.handle], tint = m ? m.tint : "#8f918a", src = lineImg(it);
      var size = it.variant_title && !it.product_has_only_default_variant ? "Size " + esc(it.variant_title) + " · " : "";
      return '<div class="line"><a class="th stage" href="' + esc(it.url) + '" style="--tint:' + tint + '" aria-label="' + esc(it.product_title) + '">' + (src ? '<img src="' + esc(src) + '" alt="">' : "") + "</a>" +
        "<div><h4>" + esc(it.product_title) + '</h4><p class="meta">' + size + money(it.final_price) + "</p>" +
        '<div class="qty sm" role="group" aria-label="Quantity, ' + esc(it.product_title) + '"><button type="button" data-lk="' + esc(it.key) + '" data-lq="' + Math.max(1, it.quantity - 1) + '" aria-label="Decrease">−</button><output>' + it.quantity + '</output><button type="button" data-lk="' + esc(it.key) + '" data-lq="' + Math.min(10, it.quantity + 1) + '" aria-label="Increase">+</button></div>' +
        '<button type="button" class="rm" data-lk="' + esc(it.key) + '" data-lq="0">Remove</button></div>' +
        '<div class="amt">' + money(it.final_line_price) + "</div></div>";
    }).join("") + upsHTML;
    var items = $("#drItems"), sub = $("#drSub");
    if (items) items.textContent = n;
    if (sub) sub.textContent = money(cart.total_price);
  }
  var lastFocus = null;
  function openBag() {
    var d = $("#drawer");
    if (!d) { window.location.href = B.routes.cart; return; }
    lastFocus = document.activeElement;
    d.removeAttribute("inert"); d.setAttribute("aria-hidden", "false"); d.classList.add("open");
    $("#scrim").hidden = false;
    hideToast();
    if (!cart) { $("#drBody").innerHTML = '<div class="empty"><p>Loading your bag…</p></div>'; }
    loadCart().catch(function () {});
    setTimeout(function () { var c = $("#drClose"); if (c) c.focus(); }, 60);
  }
  function closeBag() {
    var d = $("#drawer");
    if (!d || !d.classList.contains("open")) return;
    d.classList.remove("open"); d.setAttribute("aria-hidden", "true"); d.setAttribute("inert", "");
    $("#scrim").hidden = true;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  var tt = 0;
  function toast(text, isErr) {
    var t = $("#toast");
    if (!t) return;
    $("#toastTxt").textContent = text;
    t.querySelector("b").textContent = isErr ? "Hold on" : "Booked";
    t.classList.toggle("err", !!isErr);
    t.hidden = false; t.classList.remove("show"); void t.offsetWidth; t.classList.add("show");
    clearTimeout(tt); tt = setTimeout(hideToast, isErr ? 4200 : 5200);
  }
  function hideToast() {
    var t = $("#toast");
    clearTimeout(tt);
    if (!t || t.hidden) return;
    t.classList.remove("show");
    setTimeout(function () { if (!t.classList.contains("show")) t.hidden = true; }, 350);
  }

  /* ---------- size pickers (hero + lineup) ---------- */
  var picked = { hero: null, sc: null };
  var pickedLabel = { hero: "", sc: "" };
  function sizeButtons(p) {
    return p.variants.map(function (v) {
      return '<button type="button" class="size" data-variant="' + v.id + '" aria-pressed="false"' + (v.available ? "" : " disabled") + ">" + esc(v.title) + "</button>";
    }).join("");
  }

  /* ---------- hero ---------- */
  var hero = $("#hero");
  var heroOn = hero && $("#heroTabs") && TEES.length;
  var hi = 0, auto = !REDUCE, slideTok = 0, outAnim = null;
  function heroFill(h) {
    var m = META[h], p = prod(h), on = live(h);
    var lv = $("#hbLive"), sn = $("#hbSoon"), note = $("#hbNote"), lk = $("#hbLink");
    hero.style.setProperty("--glow", m.glow || "#c99a55");
    hero.style.setProperty("--mark-c", m.mark || "#8b6c43");
    $("#hbNo").textContent = m.no;
    $("#hbRole").textContent = m.role;
    $("#hbName").textContent = nameOf(h);
    $("#hbPrice").textContent = priceOf(h);
    if (lv) lv.hidden = !on;
    if (sn) sn.hidden = on;
    $("#hbSizes").innerHTML = on ? sizeButtons(p) : "";
    if (note) note.textContent = p ? "Sold out · Back soon" : "Coming soon · Sizes S–XL";
    if (lk) {
      lk.setAttribute("href", p ? p.url : "#scout-" + h);
      lk.textContent = p ? "See full details" : "Scout it in the lineup";
    }
    picked.hero = null;
    pickedLabel.hero = nameOf(h);
    setMsg("hero", "");
  }
  function setTurn(back) {
    $("#flip").classList.toggle("is-back", back);
    $("#turnBtn").setAttribute("aria-pressed", String(back));
    $("#turnTxt").textContent = back ? "Show front" : "Turn around";
  }
  function markTabs() {
    $$(".tab", $("#heroTabs")).forEach(function (t, j) { t.setAttribute("aria-selected", String(j === hi)); t.tabIndex = j === hi ? 0 : -1; });
  }
  function restartBar() {
    var bar = $('.tab[aria-selected="true"] .bar i');
    if (!bar) return;
    bar.style.animation = "none"; void bar.offsetWidth; bar.style.animation = "";
  }
  function stopAuto() { if (!auto) return; auto = false; hero.classList.remove("auto"); }
  function setSlide(i, user) {
    if (user) stopAuto();
    i = (i + TEES.length) % TEES.length;
    if (i === hi) return;
    var tok = ++slideTok, h = TEES[i], m = META[h], sw = $("#swap");
    hi = i; markTabs();
    var out = Promise.resolve();
    if (!REDUCE && sw.animate) {
      if (outAnim) outAnim.cancel();
      outAnim = sw.animate([{ opacity: 1, transform: "none" }, { opacity: 0, transform: "translateY(16px) scale(.94)" }], { duration: 240, easing: "ease-in", fill: "forwards" });
      out = outAnim.finished.catch(function () {});
    }
    out.then(function () {
      if (tok !== slideTok) return;
      setTurn(false);
      var f = $("#hf"), b = $("#hb");
      f.src = img(m, "front"); f.alt = nameOf(h) + ", front";
      b.src = img(m, "back"); b.alt = nameOf(h) + ", back";
      return (f.decode ? f.decode().catch(function () {}) : Promise.resolve()).then(function () {
        if (tok !== slideTok) return;
        heroFill(h);
        if (!REDUCE && sw.animate) {
          sw.animate([{ opacity: 0, transform: "translateY(-12px) scale(.96)" }, { opacity: 1, transform: "none" }], { duration: 560, easing: "cubic-bezier(.2,.7,.2,1)" });
          if (outAnim) { outAnim.cancel(); outAnim = null; }
        }
        restartBar();
      });
    });
  }
  if (heroOn) {
    $("#heroTabs").innerHTML = TEES.map(function (h, j) {
      var m = META[h];
      return '<button class="tab" type="button" role="tab" aria-selected="' + (j === 0) + '"' + (j ? ' tabindex="-1"' : "") + ' aria-controls="heroPanel"><span class="bar"><i></i></span><span class="tl"><b>' + ("0" + m.no).slice(-2) + "</b>" + esc(m.name.replace(/ Tee$/, "")) + "</span></button>";
    }).join("");
    if (TEES[0] !== "shades-tee") {
      var m0 = META[TEES[0]];
      $("#hf").src = img(m0, "front"); $("#hb").src = img(m0, "back");
    }
    heroFill(TEES[0]);
    if (auto && TEES.length > 1) hero.classList.add("auto"); else auto = false;
    hero.addEventListener("animationend", function (e) {
      if (auto && e.target.matches && e.target.matches('.tab[aria-selected="true"] .bar i')) setSlide(hi + 1, false);
    });
    $$(".tab", $("#heroTabs")).forEach(function (t, j) {
      t.addEventListener("click", function () { setSlide(j, true); });
      t.addEventListener("keydown", function (e) {
        if (e.key !== "ArrowRight" && e.key !== "ArrowLeft") return;
        e.preventDefault();
        var n = (hi + (e.key === "ArrowRight" ? 1 : -1) + TEES.length) % TEES.length;
        setSlide(n, true); $$(".tab", $("#heroTabs"))[n].focus();
      });
    });
    var toggleFlip = function () { stopAuto(); setTurn(!$("#flip").classList.contains("is-back")); };
    $("#flipBtn").addEventListener("click", toggleFlip);
    $("#turnBtn").addEventListener("click", toggleFlip);
    var hov = false, vis = true;
    var pauseUpd = function () { hero.classList.toggle("paused", hov || !vis || document.hidden); };
    $$(".hero-stage, .hero-buy, .tabs").forEach(function (el) {
      el.addEventListener("pointerenter", function () { hov = true; pauseUpd(); });
      el.addEventListener("pointerleave", function () { hov = false; pauseUpd(); });
    });
    if ("IntersectionObserver" in window) new IntersectionObserver(function (en) { vis = en[0].isIntersecting; pauseUpd(); }, { threshold: 0.2 }).observe(hero);
    document.addEventListener("visibilitychange", pauseUpd);
    if (FINE && !REDUCE) {
      var tilt = $("#tilt");
      hero.addEventListener("pointermove", function (e) {
        var r = hero.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        tilt.style.transform = "rotateY(" + (x * 16).toFixed(2) + "deg) rotateX(" + (-y * 10).toFixed(2) + "deg)";
      });
      hero.addEventListener("pointerleave", function () { tilt.style.transform = ""; });
    }
    TEES.forEach(function (h) { ["front", "back"].forEach(function (k) { var im = new Image(); im.src = img(META[h], k); }); });
  } else if (hero && $("#heroBuy")) {
    $("#heroBuy").hidden = true;
  }

  /* ---------- nav ---------- */
  var nav = $("#nav");
  function navState() {
    if (!nav || !hero || B.page !== "index") return;
    nav.classList.toggle("solid", hero.getBoundingClientRect().bottom <= nav.offsetHeight + 4);
  }
  if (nav && hero && B.page === "index") { window.addEventListener("scroll", navState, { passive: true }); navState(); }
  var menu = $("#menu");
  function openMenu() { if (!menu) return; menu.hidden = false; $("#menuBtn").setAttribute("aria-expanded", "true"); document.documentElement.style.overflow = "hidden"; setTimeout(function () { $("#menuClose").focus(); }, 30); }
  function closeMenu() { if (!menu || menu.hidden) return; menu.hidden = true; $("#menuBtn").setAttribute("aria-expanded", "false"); document.documentElement.style.overflow = ""; }

  /* ---------- lineup ---------- */
  var pitch = $("#pitch");
  function scout(h, anim) {
    var m = META[h], p = prod(h), el = $("#scout");
    if (!m || !el) return;
    picked.sc = null;
    pickedLabel.sc = p ? p.title : m.name;
    $$(".pl").forEach(function (b) { b.setAttribute("aria-pressed", String(b.getAttribute("data-scout") === h)); });
    var specs = m.specs.map(function (kv) { return "<dt>" + esc(kv[0]) + "</dt><dd>" + esc(kv[1]) + "</dd>"; }).join("");
    var cta;
    if (p && p.available && p.variants.length > 1) {
      cta = '<div class="sizes" data-ctx="sc" role="group" aria-label="Size">' + sizeButtons(p) + "</div>" +
        '<div class="scout-cta"><button class="btn btn-y" type="button" data-buy="sc">Add to bag · ' + money(p.price) + '</button><a class="btn btn-line" href="' + esc(p.url) + '">Full details</a></div><p class="msg" id="sc-msg" role="status"></p>';
    } else if (p && p.available) {
      picked.sc = p.variants[0].id;
      cta = '<div class="scout-cta"><button class="btn btn-y" type="button" data-buy="sc">Add to bag · ' + money(p.price) + '</button><a class="btn btn-line" href="' + esc(p.url) + '">Full details</a></div><p class="msg" id="sc-msg" role="status"></p>';
    } else if (p) {
      cta = '<div class="scout-cta"><span class="soon-pill">Sold out</span><a class="btn btn-line" href="' + esc(p.url) + '">Full details</a></div>';
    } else {
      cta = '<div class="scout-cta"><span class="soon-pill">Coming soon' + (m.price ? " · " + money(m.price) : "") + '</span><a class="btn btn-line" href="#notify">Get notified</a></div>';
    }
    el.innerHTML = '<div class="scout-stage stage' + (m.type === "tie" ? " tie" : "") + '" style="--tint:' + m.tint + '"><span class="bign" aria-hidden="true">' + esc(m.no) + '</span><img src="' + esc(mainImg(m)) + '" alt="' + esc(p ? p.title : m.name) + '"></div>' +
      '<div class="scout-body"><p class="k">No. ' + esc(m.no) + " · " + esc(m.role) + '</p><h3 class="d">' + esc(p ? p.title : m.name) + '</h3><p class="scout-line">' + esc(m.line) + "</p>" +
      (specs ? '<dl class="specs">' + specs + "</dl>" : "") + cta + "</div>";
    if (anim && !REDUCE && el.animate) el.animate([{ opacity: 0.35, transform: "translateY(10px)" }, { opacity: 1, transform: "none" }], { duration: 380, easing: "cubic-bezier(.2,.7,.2,1)" });
  }
  if (pitch) {
    pitch.insertAdjacentHTML("beforeend", Object.keys(META).map(function (h) {
      var m = META[h];
      if (isNaN(m.x) || isNaN(m.y)) return "";
      var x = ((m.x + 3) / 74 * 100).toFixed(2), y = ((m.y + 3) / 111 * 100).toFixed(2);
      var tee = m.type === "tee";
      var name = prod(h) ? prod(h).title : m.name;
      return '<button class="pl" type="button" data-scout="' + h + '" style="left:' + x + "%;top:" + y + '%" aria-pressed="false" aria-label="' + esc(name) + ", number " + esc(m.no) + ", " + esc(m.role) + '">' +
        '<span class="pl-top"><span class="pl-disc' + (tee ? "" : " cover") + '"><img src="' + esc(tee ? img(m, "front") : img(m, "detail")) + '" alt="" loading="lazy"></span><span class="pl-no">' + esc(m.no) + "</span></span>" +
        '<span class="pl-name">' + esc(name) + "</span></button>";
    }).join(""));
    scout(TEES[0] || Object.keys(META)[0], false);
  }
  /* links like /#scout-leopard-tee open that player's scouting card */
  function lineupScroll(smooth) {
    var ln = $("#lineup"), sc = $("#scout"), pw = $(".pitch-wrap");
    if (!ln) return;
    /* on phones the card sits under the pitch, so go straight to the card */
    var stacked = sc && pw && sc.getBoundingClientRect().top >= pw.getBoundingClientRect().bottom - 1;
    (stacked ? sc : ln).scrollIntoView({ behavior: smooth ? SMOOTH : "auto", block: "start" });
  }
  function scoutTo(h, smooth) {
    if (!pitch || !META[h]) return false;
    scout(h, smooth);
    lineupScroll(smooth);
    return true;
  }
  function scoutHash(s) { var mm = /#scout-([\w-]+)$/.exec(s || ""); return mm ? mm[1] : ""; }
  if (pitch && scoutHash(location.hash)) {
    var sh0 = scoutHash(location.hash), moved = false;
    scoutTo(sh0, false);
    ["wheel", "touchstart", "keydown"].forEach(function (ev) { window.addEventListener(ev, function () { moved = true; }, { once: true, passive: true }); });
    /* images above the lineup can shift it while loading, so settle the scroll once they're in */
    window.addEventListener("load", function () {
      if (!moved && scoutHash(location.hash) === sh0) lineupScroll(false);
    });
  }
  window.addEventListener("hashchange", function () { var h = scoutHash(location.hash); if (h) scoutTo(h, true); });

  /* ---------- tie panels ---------- */
  $$(".tp").forEach(function (tp) {
    var open = function () { $$(".tp").forEach(function (x) { x.classList.toggle("open", x === tp); }); };
    tp.addEventListener("mouseenter", open);
    tp.addEventListener("focus", open);
  });

  /* ---------- manifesto words light up on scroll ---------- */
  $$(".mani [data-split]").forEach(function (el) {
    el.innerHTML = el.textContent.split(/(\s+)/).map(function (w) { return /^\s+$/.test(w) ? w : '<span class="w">' + esc(w) + "</span>"; }).join("");
  });

  /* ---------- shop filter ---------- */
  var grid = $("#shopGrid");
  function filterShop(f) {
    if (!grid) return;
    var shown = 0;
    $$(".card", grid).forEach(function (c) {
      var ok = f === "all" || c.getAttribute("data-type") === f;
      c.hidden = !ok; if (ok) shown++;
    });
    $$("[data-filter]").forEach(function (b) { b.setAttribute("aria-pressed", String(b.getAttribute("data-filter") === f)); });
    var cnt = $("#shopCount");
    if (cnt) cnt.textContent = shown + " piece" + (shown === 1 ? "" : "s");
  }
  if (grid) filterShop("all");

  /* ---------- product page ---------- */
  var form = $("#pdpForm");
  var vid = form ? form.querySelector("#variantId") : null;
  var multi = !!(form && form.querySelector(".sz-input"));
  var qtyIn = $("#qty");
  var payWrap = $("#payWrap");
  var pdpTitle = form ? ($(".buy h1") || {}).textContent : "";
  var pdpSize = "";
  function pdpQty() { var v = qtyIn ? parseInt(qtyIn.value, 10) : 1; return Math.max(1, Math.min(10, isNaN(v) ? 1 : v)); }
  if (form) {
    form.noValidate = true;
    $$(".sz-input", form).forEach(function (r) {
      r.addEventListener("change", function () {
        if (!r.checked) return;
        vid.value = r.value; vid.disabled = false;
        pdpSize = r.getAttribute("data-title") || "";
        var pr = r.getAttribute("data-price");
        if (pr) { var a = $("#addPrice"), b = $("#pdpPrice"); if (a) a.textContent = pr; if (b) b.textContent = pr; }
        var s = $("#sbSize"); if (s) s.textContent = (pr || "") + " · Size " + pdpSize;
        if (payWrap) payWrap.classList.remove("locked");
        setMsg("pdp", "");
      });
    });
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      if (multi && !vid.value) { needSize("pdp"); return; }
      var label = (pdpTitle || "").trim() + (pdpSize ? " · Size " + pdpSize : "");
      addToBag(vid.value, pdpQty(), label, "pdp", $("#addMain"));
    });
    if (payWrap && multi) {
      payWrap.addEventListener("click", function (e) {
        if (!vid.value) { e.preventDefault(); e.stopPropagation(); needSize("pdp"); }
      }, true);
    }
    var fl = $("#fitLink");
    if (fl) fl.addEventListener("click", function () { var d = $("#fitAcc"); if (d) { d.open = true; d.scrollIntoView({ behavior: SMOOTH, block: "center" }); } });
  }
  var sbar = $("#sbar"), addMain = $("#addMain");
  if (sbar && addMain && "IntersectionObserver" in window) {
    new IntersectionObserver(function (en) { sbar.classList.toggle("show", !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(addMain);
  }
  var sbarAdd = $("#sbarAdd");
  if (sbarAdd && form) sbarAdd.addEventListener("click", function () {
    if (multi && !vid.value) { needSize("pdp"); return; }
    if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event("submit", { cancelable: true }));
  });
  var track = $("#galTrack"), thumbs = $("#galThumbs");
  if (track && thumbs) {
    var slides = $$(".slide", track);
    if (slides.length > 1) {
      thumbs.innerHTML = slides.map(function (s, i) {
        var im = s.querySelector("img");
        return '<button type="button" class="stage' + (s.classList.contains("cover") ? " cover" : "") + '" style="' + esc(s.getAttribute("style") || "") + '" data-slide="' + i + '" aria-label="' + esc(s.getAttribute("data-label") || "Image " + (i + 1)) + '" aria-current="' + (i === 0) + '">' + (im ? '<img src="' + esc(im.currentSrc || im.src) + '" alt="">' : "") + "</button>";
      }).join("");
      var cnt = $("#galCount");
      var sync = function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        $$("button", thumbs).forEach(function (b, j) { b.setAttribute("aria-current", String(j === i)); });
        if (cnt) cnt.textContent = (i + 1) + " / " + slides.length;
      };
      track.addEventListener("scroll", sync, { passive: true });
      sync();
    }
  }

  /* ---------- one click handler ---------- */
  document.addEventListener("click", function (e) {
    var t = e.target;
    var sz = t.closest(".size[data-variant]");
    if (sz && !sz.disabled) {
      var g = sz.closest(".sizes"), ctx = g.getAttribute("data-ctx");
      picked[ctx] = sz.getAttribute("data-variant");
      $$(".size", g).forEach(function (b) { b.setAttribute("aria-pressed", String(b === sz)); });
      setMsg(ctx, "");
      if (ctx === "hero") stopAuto();
      return;
    }
    var buy = t.closest("[data-buy]");
    if (buy) {
      var c = buy.getAttribute("data-buy");
      if (c === "hero") stopAuto();
      if (!picked[c]) { needSize(c); return; }
      var szb = $('.sizes[data-ctx="' + c + '"] .size[aria-pressed="true"]');
      addToBag(picked[c], 1, pickedLabel[c] + (szb ? " · Size " + szb.textContent : ""), c, buy);
      return;
    }
    var qa = t.closest(".quick [data-variant]");
    if (qa) { addToBag(qa.getAttribute("data-variant"), 1, qa.getAttribute("data-label"), null, qa); return; }
    var qb = t.closest("[data-q]");
    if (qb && qtyIn) { qtyIn.value = Math.max(1, Math.min(10, pdpQty() + Number(qb.getAttribute("data-q")))); return; }
    var lk = t.closest("[data-lk]");
    if (lk) { changeLine(lk.getAttribute("data-lk"), Number(lk.getAttribute("data-lq"))); return; }
    var ch = t.closest("[data-filter]");
    if (ch) { filterShop(ch.getAttribute("data-filter")); return; }
    var pl = t.closest("[data-scout]");
    if (pl) { scout(pl.getAttribute("data-scout"), true); return; }
    var sl = t.closest('a[href*="#scout-"]');
    if (sl && pitch && !e.metaKey && !e.ctrlKey && !e.shiftKey) {
      var u = new URL(sl.href, location.href), sh = scoutHash(u.hash);
      if (u.pathname === location.pathname && scoutTo(sh, true)) {
        e.preventDefault();
        if (history.replaceState) history.replaceState(null, "", "#scout-" + sh);
        if (menu && !menu.hidden) closeMenu();
        return;
      }
    }
    var th = t.closest("[data-slide]");
    if (th && track) { track.scrollTo({ left: track.clientWidth * Number(th.getAttribute("data-slide")), behavior: SMOOTH }); return; }
    if (t.closest("#bagBtn") || t.closest("#toastBag")) { e.preventDefault(); openBag(); return; }
    if (t.closest("#drClose") || t.closest("#scrim")) { closeBag(); return; }
    if (t.closest("#menuBtn")) { openMenu(); return; }
    if (t.closest("#menuClose")) { closeMenu(); $("#menuBtn").focus(); return; }
    var a = t.closest("a[href]");
    if (a && menu && !menu.hidden && menu.contains(a)) closeMenu();
  });
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    var d = $("#drawer");
    if (d && d.classList.contains("open")) closeBag();
    else if (menu && !menu.hidden) { closeMenu(); $("#menuBtn").focus(); }
  });
})();
